import { Injectable } from '@angular/core';
import { AbstractCacheService } from '@service/utils/cache.service';
import { ProfilePhotoService } from './profile-photo.service';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ProfilePhotoCacheService extends AbstractCacheService<string> {

    constructor(private profilePhotoService: ProfilePhotoService) {
        super();
    }

    evictCachedPhoto(email: string) {
        this.evictCachedValue(email);
    }

    getCachedPhotoByEmail(email: string, useTimestamp: boolean = false): Observable<string> {
        let profilePhotoSubscription = this.getValue(email);

        if (!profilePhotoSubscription) {
            profilePhotoSubscription = this.profilePhotoService.getPhotoByEmail(email, useTimestamp).pipe(
                shareReplay(1)
            );
            this.setValue(email, profilePhotoSubscription);
        }
        return profilePhotoSubscription;
    }

    clearPhotoCache() {
        this.clearCache();
        this.clearProfileApiSwCache().then(() => {
            // console.log('Profile API cache cleared on logout.');
        });
    }

    clearProfileApiSwCache(): Promise<Promise<boolean>[][]> {
        return caches.keys().then(cacheKeys =>
            Promise.all(
                cacheKeys.map(cacheKey => {
                    if (cacheKey.indexOf('profile-api') !== -1) {
                        return caches
                            .open(cacheKey)
                            .then(cache => cache.keys().then(requests => requests.map(req => cache.delete(req))));
                    }
                })
            )
        );
    }
}
